export var ELEMENT_APPEAR = 'appear'; // 标识元素更新

export var ELEMENT_UPDATE = 'update'; // 标识是删除的元素

export var ELEMENT_DELETE = 'delete';